import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { AuthProvider } from './features/auth/AuthContext';
import AuthGuard  from './features/auth/AuthGuard';
import { theme } from './utils/theme';
import { routingPath } from './utils/path';
import CssBaseline from '@mui/material/CssBaseline';
import { 
  LoginPage,
  MainPage,
} from './pages';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path={routingPath.login} element={<LoginPage />} />
            {/* パスワード変更やアカウントの作成は偽メールアドレス文字列のためsupabase側以外では不可 */}
            {/* <Route path={routingPath.sendEmail} element={<SendemailPage />} />
            <Route path={routingPath.passwordReset} element={<PasswordResetPage />} />
            <Route path={routingPath.signup} element={<SignupPage />} /> */}
            <Route path={routingPath.auth.all} element={<AuthGuard><MainPage/></AuthGuard>} />
            <Route path={routingPath.all} element={<LoginPage />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
